export const REGION_PORTS = [
  'North West Europe',
  'North West Europe',
  'Baltic',
  'Black Sea',
  'Central America',
  'China',
  'East Africa',
  'East Mediterranean',
  'East South America',
  'India',
  'Korea & Japan',
  'Middle East',
  'North America East',
  'North America West',
  'Oceania',
  'Russia Baltic',
  'Russia Far East',
  'Singapore',
  'South Africa',
  'South east Asia',
  'US GOM',
  'West Africa',
  'West Mediterranean',
  'West South America',
];
